/*
    This file exists because on Chrome, it was possible to click the buttons
    that create entities multiple times, causing the multiple validation of the form with
    the same data, which caused all kind of errors and corrupted our data:
        - create multiple pre-inscription to a training-session
        - create multiple trainees with the same email
        - add a same trainee to a training-session multiple times
*/

// ".create-trainee" should be here too, but Vue somehow stops this binding of events
const entityCreationButtonClasses = [".create-company", ".create-funding-agency", ".create-instructor", ".js-create-room"];

window.dataPageFormSubmittedRecently = undefined;
window.preventSpamTimeOutSubmit = undefined;

document.addEventListener("DOMContentLoaded", function () {
  const createEntityButton = getCreateEntityButton();

  if (createEntityButton) {
    window.dataPageFormSubmittedRecently = false;
    createEntityButton.addEventListener("click", preventSpamOnClickCreateEntityButton);
  }
});

export function preventSpamOnClickCreateEntityButton(e) {
  const form = document.querySelector("form");
  if (!form || !form.reportValidity()) {
    return;
  }
  if (window.dataPageFormSubmittedRecently) {
    // We block the form submission because it was already requested recently.
    if (window.preventSpamTimeOutSubmit) {
      // Cancel the previous timeout, as a new one will be created
      clearTimeout(window.preventSpamTimeOutSubmit);
    }
    e.stopPropagation();
    e.preventDefault();
  }
  window.dataPageFormSubmittedRecently = true;
  window.preventSpamTimeOutSubmit = setTimeout(() => {
    // After some delay, we re-allow the form validation, as a precaution to not permanently lock
    window.dataPageFormSubmittedRecently = false;
  }, 5000);
}

function getCreateEntityButton() {
  for (const buttonClass of entityCreationButtonClasses) {
    if (document.querySelector(buttonClass) !== null) {
      return document.querySelector(buttonClass);
    }
  }
  return null;
}
